var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministratorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252.16,
    height: 231.418,
    viewBox: "0 0 252.16 231.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shadwork-logo",
    transform: "translate(1.668 0.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M0,.16C17.12,13.726,31.393,28.493,42.5,44.132,54.13,60.508,62.193,77.708,66.491,95.311A112.375,112.375,0,0,0,66.9,45.688,125.074,125.074,0,0,0,54.838,13.425Z",
    transform: "translate(0.01 17.66)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M23.64,29.5a285.186,285.186,0,0,1,45.042,7c29.392,7,56.674,18.609,80.2,34.129-3.8-3.164-9.079-7.4-15.693-12.161A352.608,352.608,0,0,0,101.727,38.7C83.771,28.831,48.437,13.685,0,.16H0A186.489,186.489,0,0,1,13.379,15.346C17.3,20.289,20.7,25.074,23.64,29.5Z",
    transform: "translate(0.01 -0.16)",
    fill: "#0d6986",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M179.593,160.65c-37.1-40.945-80.549-67.377-126.343-76.86,36.382-7.88,73.492-3.529,108.589,12.729Z",
    transform: "translate(70.417 69.35)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M112.6,161.167a225.993,225.993,0,0,0-8.422-43.238A221.517,221.517,0,0,0,63.85,41c3.735,3.625,8.724,8.7,14.338,15.009a332.047,332.047,0,0,1,23.34,30.163c11.6,17.208,29.628,51.068,45.706,97.424h0c-5.313-4.133-11.276-8.435-17.888-12.664C123.523,167.209,117.909,163.97,112.6,161.167Z",
    transform: "translate(58.743 58.341) rotate(-14)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M0,165.062C22.458,148.027,40.88,129.53,54.835,110,68.61,90.719,77.947,70.585,82.635,50.06a194.078,194.078,0,0,1,3.443,46.48,197.655,197.655,0,0,1-6.5,41.708Z",
    transform: "translate(0.01 44.911)",
    fill: "#0d6986",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M0,131.824C45.806,104.782,99.055,87.65,154.9,81.985A577.841,577.841,0,0,0,36.086,83.733Q18.074,107.791,0,131.824Z",
    transform: "translate(27.31 98.176)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorImage);
export default __webpack_public_path__ + "static/media/administrator_image.de9026043944d37d72c23e50f6107153.svg";
export { ForwardRef as ReactComponent };